import { useQuery } from '@tanstack/vue-query'
import { queries } from '~/keys/index'
import { DEFAULT_CACHE_TIME } from '~/constants'
import type { SuccessResponse } from '~/types/response'
import type { Country } from '~/types/common'

const useCountries = () => {
  const { fetch } = useAPIFetch()

  return useQuery({
    ...queries.dictionaries.countries,
    queryFn: () =>
      fetch<SuccessResponse<Country[]>>({
        method: 'GET',
        url: 'countries',
        params: {
          fields: 'id,name,phone_code,iso2,timezones',
        },
      }),
    staleTime: DEFAULT_CACHE_TIME,
    select: data => data.data,
  })
}

export default useCountries
